import { render, staticRenderFns } from "./CandidatesEmail.vue?vue&type=template&id=039ea912&lang=pug"
import script from "./CandidatesEmail.vue?vue&type=script&lang=js"
export * from "./CandidatesEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports